module.exports = __webpack_public_path__ + "static/media/badboys.af324fc2.mp3";